"use strict";

exports.__esModule = true;
exports.getApplicationConfig = exports.getApplicationConfigFromContext = exports.getCommunitiesContext = void 0;

var _lodash = require("lodash");

var getCommunitiesContext = function getCommunitiesContext(state) {
  return state.communitiesContext;
};

exports.getCommunitiesContext = getCommunitiesContext;

var getApplicationConfigFromContext = function getApplicationConfigFromContext(communitiesContext, appDefinitionId) {
  return (0, _lodash.get)(communitiesContext, appDefinitionId, {});
};

exports.getApplicationConfigFromContext = getApplicationConfigFromContext;

var getApplicationConfig = function getApplicationConfig(state, appDefinitionId) {
  return getApplicationConfigFromContext(getCommunitiesContext(state), appDefinitionId);
};

exports.getApplicationConfig = getApplicationConfig;